const WouldUrideTaolaReservationComplete = () => import('../views/taola/wouldUride/WouldUrideTaolaReservationComplete.vue')
const WouldUrideTaolaEvent = () => import('../views/taola/wouldUride/WouldUrideTaolaEvent.vue')

export default [
  {
    path: '/wouldu-event',
    name: 'wouldu-event',
    component: WouldUrideTaolaEvent
  },
  
  {
    path: '/wouldu-complete',
    name: 'wouldu-complete',
    component: WouldUrideTaolaReservationComplete
  },
    // {
    //   path: '/survey/CM/:wave_number',
    //   name: 'chiangmai-survey',
    //   component: Survey2
    // },
]